import { ReactNode } from 'react';

interface PublicLayoutProps {
  content: ReactNode;
}

export const PublicLayout = ({ content }: PublicLayoutProps) => (
  <div>{content}</div>
);
